"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useStyleSet;

var _useWebChatUIContext = _interopRequireDefault(require("./internal/useWebChatUIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useStyleSet() {
  return [(0, _useWebChatUIContext.default)().styleSet];
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ob29rcy91c2VTdHlsZVNldC50cyJdLCJuYW1lcyI6WyJ1c2VTdHlsZVNldCIsInN0eWxlU2V0Il0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7Ozs7QUFFZSxTQUFTQSxXQUFULEdBQThCO0FBQzNDLFNBQU8sQ0FBQyxvQ0FBc0JDLFFBQXZCLENBQVA7QUFDRCIsInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHVzZVdlYkNoYXRVSUNvbnRleHQgZnJvbSAnLi9pbnRlcm5hbC91c2VXZWJDaGF0VUlDb250ZXh0JztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gdXNlU3R5bGVTZXQoKTogW2FueV0ge1xuICByZXR1cm4gW3VzZVdlYkNoYXRVSUNvbnRleHQoKS5zdHlsZVNldF07XG59XG4iXX0=